"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FloatingTradeHub = void 0;
const CardName_1 = require("../../CardName");
const CardRenderer_1 = require("../render/CardRenderer");
const PreludeCard_1 = require("../prelude/PreludeCard");
const Tags_1 = require("../Tags");
const ResourceType_1 = require("../../ResourceType");
const OrOptions_1 = require("../../inputs/OrOptions");
const SelectCard_1 = require("../../inputs/SelectCard");
const SelectOption_1 = require("../../inputs/SelectOption");
const SelectAmount_1 = require("../../inputs/SelectAmount");
const Resources_1 = require("../../Resources");
const Size_1 = require("../render/Size");
class FloatingTradeHub extends PreludeCard_1.PreludeCard {
    constructor() {
        super({
            name: CardName_1.CardName.FLOATING_TRADE_HUB,
            tags: [Tags_1.Tags.SPACE],
            resourceType: ResourceType_1.ResourceType.FLOATER,
            metadata: {
                cardNumber: 'P49',
                renderData: CardRenderer_1.CardRenderer.builder((b) => {
                    b.preludeBox('action', (ce) => {
                        ce.vSpace(Size_1.Size.SMALL);
                        ce.vSpace();
                        ce.action(undefined, (eb) => {
                            eb.empty().startAction.floaters(2).asterix();
                        });
                        ce.vSpace(Size_1.Size.SMALL);
                        ce.action('Add 2 floaters to ANY CARD, or remove any number of floaters here to gain that many of one standard resource.', (eb) => {
                            eb.text('X').floaters(1).startAction.text('X').wild(1);
                        });
                        ce.vSpace();
                    });
                }),
            },
        });
        this.resourceCount = 0;
    }
    play() {
        return undefined;
    }
    canAct() {
        return true;
    }
    action(player) {
        const floaterCards = player.getResourceCards(ResourceType_1.ResourceType.FLOATER);
        if (this.resourceCount === 0 && floaterCards.length === 1) {
            player.addResourceTo(this, { qty: 2, log: true });
            return undefined;
        }
        const addResourceOption = new SelectCard_1.SelectCard('Select card to add 2 floaters', 'Add floaters', floaterCards, (foundCards) => {
            player.addResourceTo(foundCards[0], { qty: 2, log: true });
            return undefined;
        });
        if (this.resourceCount === 0)
            return addResourceOption;
        const orOptions = new OrOptions_1.OrOptions();
        const spendResourceOption = new SelectAmount_1.SelectAmount('Remove any number of floaters to gain standard resources', 'Remove floaters', (amount) => {
            return new OrOptions_1.OrOptions(new SelectOption_1.SelectOption(`Gain ${amount} titanium`, 'Gain titanium', () => {
                player.removeResourceFrom(this, amount);
                player.addResource(Resources_1.Resources.TITANIUM, amount, { log: true });
                return undefined;
            }), new SelectOption_1.SelectOption(`Gain ${amount} steel`, 'Gain steel', () => {
                player.removeResourceFrom(this, amount);
                player.addResource(Resources_1.Resources.STEEL, amount, { log: true });
                return undefined;
            }), new SelectOption_1.SelectOption(`Gain ${amount} plants`, 'Gain plants', () => {
                player.removeResourceFrom(this, amount);
                player.addResource(Resources_1.Resources.PLANTS, amount, { log: true });
                return undefined;
            }), new SelectOption_1.SelectOption(`Gain ${amount} energy`, 'Gain energy', () => {
                player.removeResourceFrom(this, amount);
                player.addResource(Resources_1.Resources.ENERGY, amount, { log: true });
                return undefined;
            }), new SelectOption_1.SelectOption(`Gain ${amount} heat`, 'Gain heat', () => {
                player.removeResourceFrom(this, amount);
                player.addResource(Resources_1.Resources.HEAT, amount, { log: true });
                return undefined;
            }), new SelectOption_1.SelectOption(`Gain ${amount} M€`, 'Gain M€', () => {
                player.removeResourceFrom(this, amount);
                player.addResource(Resources_1.Resources.MEGACREDITS, amount, { log: true });
                return undefined;
            }));
        }, 1, this.resourceCount, true);
        orOptions.options.push(new SelectOption_1.SelectOption('Remove any number of floaters to gain standard resources', 'Select', () => {
            return spendResourceOption;
        }));
        if (floaterCards.length === 1) {
            orOptions.options.push(new SelectOption_1.SelectOption(`Add 2 floaters to ${this.name}`, 'Select', () => {
                player.addResourceTo(this, { qty: 2, log: true });
                return undefined;
            }));
        }
        else {
            orOptions.options.push(new SelectOption_1.SelectOption('Add 2 floaters to a card', 'Select', () => {
                return addResourceOption;
            }));
        }
        return orOptions;
    }
}
exports.FloatingTradeHub = FloatingTradeHub;
//# sourceMappingURL=FloatingTradeHub.js.map